import { css } from '@emotion/react'
import { rem } from 'polished'

export const card = css({
  width: rem(140),
})
